module.exports = __webpack_public_path__ + "img/feature-upload-email-school.5c5af1c3.png";